'use client';

import { useState, useEffect, useRef } from 'react';
import LoadableImage from './loadable-image';
import styles from '@/styles/components/image-carousel.module.scss';
import classNames from 'classnames';
import { images } from 'sdk';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Zoom } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import 'swiper/scss/zoom';

export default function ImageCarousel(props: {
  photos: string[];
  altText?: string;
}) {
  const [activePhoto, setActivePhoto] = useState(
    props.photos.length ? props.photos[0] : null
  );
  const swiperRef = useRef(null);

  useEffect(() => {
    setActivePhoto(props.photos[0]);
  }, [props.photos]);


  function hasMultipleImages() {
    return props.photos.length > 1;
  }


  function image(path) {
    if (!path) return;

    return (
      <div
        className={`${styles['carousel-main-image']}`}
      >
        <LoadableImage
          src={images(path).imageCarousel.main}
          alt={props.altText}
          width={800}
          height={800}
        />
      </div>

    );
  }

  return (
    <div className={styles.carousel}>
      <Swiper
        ref={swiperRef}
        className={styles['carousel-swiper']}
        slidesPerView={1}
        onSlideChange={(swiper) => {
          setActivePhoto(props.photos[swiper.activeIndex]);
        }}
        zoom={{
          maxRatio: 3,
          minRatio: 1,
          toggle: true
        }}
        navigation={true}
        modules={[Navigation, Pagination, Zoom]}
        pagination={{
          enabled: true,
          type: 'bullets'
        }}
        touchEventsTarget="container"
        breakpoints={{
          992: {
            pagination: {
              enabled: false,
            },
            zoom: {
              toggle: false
            }
          }
        }}
      >
        {props.photos.map((path) => {
          return <SwiperSlide key={path} zoom>
            {image(path)}
          </SwiperSlide>;
        })}
      </Swiper>
      {hasMultipleImages() && (
        <div className={styles['carousel-thumbnail-container']}>
          {props.photos.map((path) => {
            return (
              <div
                key={path}
                onClick={() => {
                  swiperRef.current.swiper.slideTo(props.photos.indexOf(path));
                }}
                className={classNames(styles['carousel-thumbnail'], {
                  [styles['carousel-thumbnail--active']]: activePhoto === path,
                })}
              >
                {image(path)}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );

}
